export default __webpack_public_path__ + "static/media/icon_craftsman.5665ef46.svg";